<template>
  <v-container fluid class="pa-0">
    <app-toolbar />
    <v-navigation-drawer
      :value="!$vuetify.breakpoint.mdAndDown || $store.getters['modules/showDrawer']"
      app
      clipped
      floating
      class="shadow"
      @input="onInput"
    >
      <v-card color="#dff5ff" class="fill-height inherit-color">
        <v-list>
          <v-list-group
            sub-group
            :prepend-icon="item.icon"
            v-for="(item, index) in items"
            :key="item.name + index"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(subitem, kindex) in item.childrens"
              :key="subitem.name + kindex"
              :to="subitem.to"
            >
              <v-list-item-icon>
                <v-icon>{{ subitem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ subitem.name }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-if="['ADMIN', 'ASSISTANT'].includes($store.state.profile.role)"
            to="/cloud"
          >
            <v-list-item-icon class="pl-4">
              <v-icon> mdi-cloud </v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n3"> Arches Cloud </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-navigation-drawer>
    <v-main :style="`min-height: ${$vuetify.breakpoint.height}px`">
      <router-view></router-view>
    </v-main>
  </v-container>
</template>
<script>
import Toolbar from "./Toolbar";
export default {
  components: {
    appToolbar: Toolbar,
  },
  data() {
    return {
      items:
        this.$store.state.profile?.role === "EDITOR"
          ? [
              {
                name: "School",
                icon: "mdi-school",
                childrens: [
                  {
                    name: "Lessons",
                    to: { name: "admin-lessons" },
                    icon: "mdi-pencil",
                  },
                ],
              },
            ]
          : this.$store.state.profile?.role === "ASSISTANT"
            ? [
                {
                  name: "Accounts",
                  icon: "mdi-account",
                  childrens: [
                    {
                      name: "Teachers",
                      to: {
                        name: "admin-teachers",
                        params: {
                          isTeacher: true,
                        },
                      },
                      icon: "mdi-human-male-board",
                    },
                    {
                      name: "Students",
                      to: {
                        name: "admin-students",
                        params: {
                          isTeacher: false,
                        },
                      },
                      icon: "mdi-school-outline",
                    },
                    {
                      name: "Landing Page",
                      to: {
                        name: "admin-potential-users",
                        params: {
                          isTeacher: false,
                        },
                      },
                      icon: "mdi-account-multiple-plus-outline",
                    },
                  ],
                },
                {
                  name: "CRM",
                  icon: "mdi-chart-multiple",
                  childrens: [
                    {
                      name: "Active Students",
                      to: {
                        name: "admin-active-contacts",
                      },
                      icon: "mdi-check-all",
                    },
                    {
                      name: "Inactive Students",
                      to: {
                        name: "admin-inactive-contacts",
                      },
                      icon: "mdi-checkbox-multiple-blank-outline",
                    },
                    {
                      name: "Potential Students",
                      to: {
                        name: "admin-potential-contacts",
                      },
                      icon: "mdi-check-box-multiple-outline",
                    },
                  ],
                },
              ]
            : [
                {
                  name: "School",
                  icon: "mdi-school",
                  childrens: [
                    {
                      name: "Levels",
                      to: { name: "admin-level" },
                      icon: "mdi-notebook",
                    },
                    {
                      name: "Modules",
                      to: { name: "admin-modules" },
                      icon: "mdi-book",
                    },
                    {
                      name: "Lessons",
                      to: { name: "admin-lessons" },
                      icon: "mdi-pencil",
                    },
                  ],
                },
                {
                  name: "Accounts",
                  icon: "mdi-account",
                  childrens: [
                    {
                      name: "Teachers",
                      to: {
                        name: "admin-teachers",
                        params: {
                          isTeacher: true,
                        },
                      },
                      icon: "mdi-human-male-board",
                    },
                    {
                      name: "Students",
                      to: {
                        name: "admin-students",
                        params: {
                          isTeacher: false,
                        },
                      },
                      icon: "mdi-school-outline",
                    },
                    {
                      name: "Landing Page",
                      to: {
                        name: "admin-potential-users",
                        params: {
                          isTeacher: false,
                        },
                      },
                      icon: "mdi-account-multiple-plus-outline",
                    },
                  ],
                },
                {
                  name: "CRM",
                  icon: "mdi-chart-multiple",
                  childrens: [
                    {
                      name: "All Students",
                      to: {
                        name: "admin-all-contacts",
                      },
                      icon: "mdi-account-group",
                    },
                    {
                      name: "Active Students",
                      to: {
                        name: "admin-active-contacts",
                      },
                      icon: "mdi-check-all",
                    },
                    {
                      name: "Inactive Students",
                      to: {
                        name: "admin-inactive-contacts",
                      },
                      icon: "mdi-checkbox-multiple-blank-outline",
                    },
                    {
                      name: "Potential Students",
                      to: {
                        name: "admin-potential-contacts",
                      },
                      icon: "mdi-checkbox-multiple-outline",
                    },
                  ],
                },
              ],
    };
  },
  methods: {
    onInput(e) {
      this.$store.commit("modules/toggleDrawer", e);
    },
  },
};
</script>
<style scoped></style>
